/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 1/15/14
 * Time: 6:16 PM
 * To change this template use File | Settings | File Templates.
 */
/**
 position(): will calculate the position coordinates of the floating element according the target element.
 2 input parameters:
 ** options:
 - targetEl: Required - the target element
 - floatingEl: Required - the floating element
 - gap: Optional - the space between the target element and the floating element - default: 10
 - position: Optional - PositionEntity.POSITION of the floating element - default: PositionEntity.POSITION.TOP
 - align: Optional - PositionEntity.ALIGN of the floating element - default: PositionEntity.ALIGN.MIDDLE
 ** cb: the callback method when positioning is done

 you will first need to map your position and align enum with the PositionEntry.POSITION and PositionEntry.ALIGN enums

 when positioning is done it calls the cb method.
 argument is an object with the following properties:
 - isValid: boolean - true if the positioning occured successfully
 - err: string - the error message if positioning failed
 - cls: string - the conventional class name for the positioning (position and alignment). See below for details
 - left: int - the css left coordinate of the floating element
 - top: int - the css top coordinate of the floating element

 conventional css for positioning:
 the floating element must have the following classes for the positioning:
 - left, top, right, bottom for position
 - align-left, align-top, align-right, align-bottom for alignment
 for instance the floating element is positioned on the top and right aligned with the target element will have the following classes: class="top align-right"

 Example of use:
 this.positionMap = {};
 this.positionMap[Bubble.POSITION.TOP] = PositionUtils.PositionEntity.POSITION.TOP;
 this.positionMap[Bubble.POSITION.BOTTOM] = PositionUtils.PositionEntity.POSITION.BOTTOM;
 this.positionMap[Bubble.POSITION.LEFT] = PositionUtils.PositionEntity.POSITION.LEFT;
 this.positionMap[Bubble.POSITION.RIGHT] = PositionUtils.PositionEntity.POSITION.RIGHT;
 this.alignMap = {};
 this.alignMap[Bubble.ALIGN.LEFT] = PositionUtils.PositionEntity.ALIGN.LEFT;
 this.alignMap[Bubble.ALIGN.RIGHT] = PositionUtils.PositionEntity.ALIGN.RIGHT;
 this.alignMap[Bubble.ALIGN.MIDDLE] = PositionUtils.PositionEntity.ALIGN.MIDDLE;
 this.alignMap[Bubble.ALIGN.TOP] = PositionUtils.PositionEntity.ALIGN.TOP;
 this.alignMap[Bubble.ALIGN.BOTTOM] = PositionUtils.PositionEntity.ALIGN.BOTTOM;

 PositionUtils.position({
                targetEl: this.options.targetControl,
                floatingEl: this.ui.bubble,
                position: this.positionMap[this.options.position],
                align: this.alignMap[this.options.align]
            }, _.bind(this.onPositionCalculated, this));

 onPositionCalculated: function(pos){
            if (pos.isValid){
                this.ui.bubble.addClass(pos.cls);
                this.ui.bubble.css({"top": pos.top, "left": pos.left});
                this.display();
            }
            else {
                this.logger.error(pos.err);
            }
        }

 */
define(function (require) {
    "use strict";

    var $ = require('jquery');
    var _ = require('underscore');
    require("jqueryui/position");

    var PositionUtils = function (){

        var version = '1.0';
        var PositionEntity = PositionEntity || {};
        var _positionConfig = _positionConfig || {};


        PositionEntity.POSITION = {
            TOP: 1,
            RIGHT: 2,
            BOTTOM: 3,
            LEFT: 4
        };

        PositionEntity.ALIGN = {
            MIDDLE: 1,
            LEFT: 2,
            RIGHT: 3,
            TOP: 4,
            BOTTOM: 5
        };

        _positionConfig = {
            cls: {
                position: {
                    top: "top",
                    right: "right",
                    bottom: "bottom",
                    left: "left"
                },
                align: {
                    middle: "align-middle",
                    top: "align-top",
                    right: "align-right",
                    bottom: "align-bottom",
                    left: "align-left"
                }
            },
            alignMap: {
                1: "center",
                2: "left",
                3: "right",
                4: "top",
                5: "bottom"
            }
        };

        var _validateOptions = function(options){
            var result = {isValid:false, err:""};
            if (_.isUndefined(options.targetEl)){
                result.err = "PositionUtils::_validateOptions - missing targetEl";
                return result;
            }
            if (_.isUndefined(options.floatingEl)){
                result.err = "PositionUtils::_validateOptions - missing floatingEl";
                return result;
            }
            result.isValid = true;
            return result;
        };

        var _setPositionMapping = function(gap){
            _positionConfig.positionMap = {
                1: {//TOP
                    my: function(align, alignMap){
                        return alignMap[align] + " bottom-" + gap;
                    },
                    at: function(align, alignMap){
                        return alignMap[align] + " top";
                    }
                },
                2: {//RIGHT
                    my: function(align, alignMap){
                        return "left+"  + gap + " " + alignMap[align];
                    },
                    at: function(align, alignMap){
                        return "right " + alignMap[align];
                    }
                },
                3: {//BOTTOM
                    my: function(align, alignMap){
                        return alignMap[align] + " top+" + gap;
                    },
                    at: function(align, alignMap){
                        return alignMap[align] + " bottom";
                    }
                },
                4: {//LEFT
                    my: function(align, alignMap){
                        return "right-" + gap + " " + alignMap[align];
                    },
                    at: function(align, alignMap){
                        return "left " + alignMap[align];
                    }
                }
            };
        };

        var _setPosition = function(options, cb){
            _setPositionMapping(options.gap);
            var positionSettings = {};
            positionSettings.position = options.position;
            positionSettings.align = options.align;
            positionSettings.floatingEl = options.floatingEl;

            options.floatingEl.position({
                my : _positionConfig.positionMap[options.position].my(options.align, _positionConfig.alignMap),
                at : _positionConfig.positionMap[options.position].at(options.align, _positionConfig.alignMap),
                of : $(options.targetEl),
                collision: "flip",
                using: _.bind(_adjustPosition, {cb: cb, positionSettings:positionSettings})
            });
        };

        var _adjustPosition = function(coordinates, feedback){
            var cls = "";
            var top = coordinates.top;
            var left = coordinates.left;
            var position = this.positionSettings.position;
            var align = this.positionSettings.align;


            switch (this.positionSettings.position){
                case PositionEntity.POSITION.TOP: //TOP
                    if (feedback.element.top >= feedback.target.top) {
                        cls = _positionConfig.cls.position.bottom;
                        position = PositionEntity.POSITION.BOTTOM;
                    }
                    else {
                        cls = _positionConfig.cls.position.top;
                        position = PositionEntity.POSITION.TOP;
                    }
                    break;
                case PositionEntity.POSITION.RIGHT: //RIGHT
                    if (feedback.element.left <= feedback.target.left) {
                        cls = _positionConfig.cls.position.left;
                        position = PositionEntity.POSITION.LEFT;
                    }
                    else {
                        cls = _positionConfig.cls.position.right;
                        position = PositionEntity.POSITION.RIGHT;
                    }
                    break;
                case PositionEntity.POSITION.BOTTOM: //BOTTOM
                    if (feedback.element.top <= feedback.target.top) {
                        cls = _positionConfig.cls.position.top;
                        position = PositionEntity.POSITION.TOP;
                    }
                    else {
                        cls = _positionConfig.cls.position.bottom;
                        position = PositionEntity.POSITION.BOTTOM;
                    }
                    break;
                case PositionEntity.POSITION.LEFT: //LEFT
                    if (feedback.element.left >= feedback.target.left) {
                        cls = _positionConfig.cls.position.right;
                        position = PositionEntity.POSITION.RIGHT;
                    }
                    else {
                        cls = _positionConfig.cls.position.left;
                        position = PositionEntity.POSITION.LEFT;
                    }
                    break;
            }
            if (this.positionSettings.align !== PositionEntity.ALIGN.MIDDLE){
                this.positionSettings.floatingEl.removeClass(_positionConfig.cls.align.top).removeClass(_positionConfig.cls.align.left).removeClass(_positionConfig.cls.align.right).removeClass(_positionConfig.cls.align.bottom);

                switch (this.positionSettings.align){
                    case PositionEntity.ALIGN.BOTTOM: //BOTTOM
                        if (Math.abs(feedback.element.top - feedback.target.top) >= 0.5) {  //math abs for ie bug
                            cls = cls + " " +  _positionConfig.cls.align.bottom;
                            align = PositionEntity.ALIGN.BOTTOM;
                        }
                        else {
                            cls = cls + " " +  _positionConfig.cls.align.top;
                            align = PositionEntity.ALIGN.TOP;
                        }
                        break;
                    case PositionEntity.ALIGN.TOP: //TOP
                        if (Math.abs(feedback.element.top - feedback.target.top) <= 0.5) {  //math abs for ie bug
                            cls = cls + " " +  _positionConfig.cls.align.top;
                            align = PositionEntity.ALIGN.TOP;
                        }
                        else {
                            cls = cls + " " +  _positionConfig.cls.align.bottom;
                            align = PositionEntity.ALIGN.BOTTOM;
                        }
                        break;
                    case PositionEntity.ALIGN.LEFT: //LEFT
                        if (Math.abs(feedback.element.left - feedback.target.left) <= 0.5) {
                            cls = cls + " " + _positionConfig.cls.align.left;
                            align = PositionEntity.ALIGN.LEFT;
                        }
                        else {
                            cls = cls + " " +  _positionConfig.cls.align.right;
                            align = PositionEntity.ALIGN.RIGHT;
                        }
                        break;
                    case PositionEntity.ALIGN.RIGHT: //RIGHT
                        if (Math.abs((feedback.element.left + feedback.element.width) - (feedback.target.left + feedback.target.width)) <= 0.5) {
                            cls = cls + " " + _positionConfig.cls.align.right;
                            align = PositionEntity.ALIGN.RIGHT;
                        }
                        else {
                            cls = cls + " " +  _positionConfig.cls.align.left;
                            align = PositionEntity.ALIGN.LEFT;
                        }
                        break;
                }
            }

            this.cb({isValid:true, err:"", cls:cls,left:left,top:top, position:position, align:align});
        };

        return{

            PositionEntity: PositionEntity,

            position: function(options, cb){
                var result = {isValid: false, err:"", cls:"", left:0, top:0};
                var defaultOptions = {gap: 10, position: PositionEntity.POSITION.TOP, align: PositionEntity.ALIGN.MIDDLE};
                options = $.extend({}, defaultOptions, options );
                var validOptions = _validateOptions(options);
                if (!validOptions.isValid){
                    result.err = validOptions.err;
                    cb(result);
                }
                _setPosition(options, cb);
            }
        };
    };

    return new PositionUtils();
});

